import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-phone-accepting.component.ajs.html';

const MODULE_NAME = 'agentBookingPhoneAccepting';

class AgentBookingPhoneAcceptingCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingPhoneAccepting implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingPhoneAcceptingCtrl];
}

export default MODULE_NAME;
